<template>
  <ComboboxItem>
    <Component
      :is="isTruncated ? Tooltip : Primitive"
      :asChild="!isTruncated"
      :delay="300"
      :side="'right'"
      :title="item.label"
    >
      <div class="px-2.5 flex gap-2 items-center truncate">
        <Icon
          :name="item.icon"
          class="fg-quaternary group-focus:text-secondary group-disabled:fg-disabled"
        />
        <span class="truncate grow text-left" ref="labelElement">
          {{ item.label }}
        </span>
      </div>
    </Component>
  </ComboboxItem>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { ComboboxItem, Primitive } from "radix-vue";
import { Tooltip } from "@/SharedComponents/Tooltips";
import { Icon } from "@/SharedComponents/Icon";
import { isTruncating } from "@/Utils/truncate";

const labelElement = ref(null);
const isTruncated = ref(false);

onMounted(() => {
  setTimeout(() => {
    isTruncated.value = isTruncating(labelElement.value);
  }, 500);
});

defineProps({
  item: {
    type: Object,
    required: true,
  },
});
</script>
